var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user" },
    [
      !_vm.userDetail
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true },
          })
        : _vm._e(),
      _c("div", { staticClass: "infos" }, [
        _vm.page.network == "linkedin" && _vm.user && _vm.user.logoV2
          ? _c("img", {
              staticClass: "image-user",
              attrs: { src: _vm.user.logoV2, alt: _vm.user.localizedName },
            })
          : _vm.user.picture
          ? _c("img", {
              staticClass: "image-user",
              attrs: {
                alt: _vm.user.name || _vm.user.username,
                src: _vm.user.picture.data.url,
              },
            })
          : _c("img", {
              staticClass: "image-user",
              attrs: { src: "img/avatar.jpg" },
            }),
        _c("div", { staticClass: "container-name" }, [
          _c(
            "div",
            { staticClass: "name" },
            [
              _vm.user.block
                ? _c(
                    "Tooltip",
                    { attrs: { text: _vm.$t("dash.inbox.user.blocked") } },
                    [_c("i", { staticClass: "fa-solid fa-lock" })]
                  )
                : _vm._e(),
              _c("a", { attrs: { href: _vm.user.link, target: "_blank" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.user.name ||
                        _vm.user.username ||
                        _vm.user.localizedName ||
                        "Aucun résultat"
                    ) +
                    "   \n        "
                ),
              ]),
              _c(
                "div",
                { staticClass: "more" },
                [
                  _c(
                    "ContextMenu",
                    {
                      attrs: {
                        options: _vm.getOptionContextMenu,
                        id: "blockUser",
                      },
                      on: { clickOption: _vm.clickOptionUser },
                    },
                    [_c("i", { staticClass: "fa-solid fa-ellipsis-vertical" })]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "container-count" }, [
          _c(
            "div",
            {
              staticClass: "count-activities",
              on: { click: _vm.getActivities },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.userDetail && _vm.userDetail.count_activities
                      ? _vm.userDetail.count_activities
                      : 0
                  )
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.userDetail && _vm.userDetail.count_activities > 1
                      ? _vm.$t("dash.inbox.user.count_activities")
                      : _vm.$t("dash.inbox.user.count_activity")
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "expand",
            on: {
              click: function ($event) {
                _vm.showDetails = !_vm.showDetails
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa-solid fa-chevron-right",
              class: { open: _vm.showDetails },
            }),
          ]
        ),
      ]),
      _vm.showDetails
        ? _c("div", { staticClass: "details" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("dash.inbox.user.personal_data"))),
            ]),
            _c("div", { staticClass: "user-infos" }, [
              _c("div", { staticClass: "email" }, [
                _vm._m(0),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.inbox.user.email.title"))),
                  ]),
                  _c("div", { staticClass: "list" }, [
                    _vm.userDetail._source
                      ? _c(
                          "ul",
                          _vm._l(
                            _vm.userDetail._source.emails,
                            function (email, key) {
                              return _c("li", { key: key }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(email) +
                                    "\n                "
                                ),
                                _c("i", { staticClass: "fa-solid fa-pen" }),
                                _c("i", {
                                  staticClass: "fa-regular fa-trash-can",
                                }),
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    !_vm.showAddEmail
                      ? _c(
                          "div",
                          {
                            staticClass: "add-email",
                            on: {
                              click: function ($event) {
                                return _vm.showInput("email")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("dash.inbox.user.add_email")))]
                        )
                      : _vm._e(),
                    _vm.showAddEmail
                      ? _c("div", { staticClass: "container-input" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailToAdd,
                                expression: "emailToAdd",
                              },
                            ],
                            ref: "inputTitle",
                            attrs: {
                              placeholder: _vm.$t(
                                "dash.inbox.user.email_placeholder"
                              ),
                              type: "text",
                              name: "email",
                            },
                            domProps: { value: _vm.emailToAdd },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.addEmail.apply(null, arguments)
                              },
                              blur: _vm.hideInput,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.emailToAdd = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "fa-solid fa-check",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addEmail.apply(null, arguments)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "phone" }, [
                _vm._m(1),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.inbox.user.phone.title"))),
                  ]),
                  _c("div", { staticClass: "list" }, [
                    _vm.userDetail._source
                      ? _c(
                          "ul",
                          _vm._l(
                            _vm.userDetail._source.phones,
                            function (phone, key) {
                              return _c("li", { key: key }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(phone) +
                                    "\n                "
                                ),
                                _c("i", { staticClass: "fa-solid fa-pen" }),
                                _c("i", {
                                  staticClass: "fa-regular fa-trash-can",
                                }),
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    !_vm.showAddPhone
                      ? _c(
                          "div",
                          {
                            staticClass: "add-phone",
                            on: {
                              click: function ($event) {
                                return _vm.showInput("phone")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("dash.inbox.user.add_phone")))]
                        )
                      : _vm._e(),
                    _vm.showAddPhone
                      ? _c("div", { staticClass: "container-input" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phoneToAdd,
                                expression: "phoneToAdd",
                              },
                            ],
                            ref: "inputTitle",
                            attrs: {
                              placeholder: _vm.$t(
                                "dash.inbox.user.phone_placeholder"
                              ),
                              type: "text",
                              name: "phone",
                            },
                            domProps: { value: _vm.phoneToAdd },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.addPhone.apply(null, arguments)
                              },
                              blur: _vm.hideInput,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.phoneToAdd = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "fa-solid fa-check",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addPhone.apply(null, arguments)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "url" }, [
                _vm._m(2),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.inbox.user.url.title"))),
                  ]),
                  _c("div", { staticClass: "list" }, [
                    _vm.userDetail._source
                      ? _c(
                          "ul",
                          _vm._l(
                            _vm.userDetail._source.urls,
                            function (url, key) {
                              return _c("li", { key: key }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(url) +
                                    "\n                "
                                ),
                                _c("i", { staticClass: "fa-solid fa-pen" }),
                                _c("i", {
                                  staticClass: "fa-regular fa-trash-can",
                                }),
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    !_vm.showAddUrl
                      ? _c(
                          "div",
                          {
                            staticClass: "add-url",
                            on: {
                              click: function ($event) {
                                return _vm.showInput("url")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("dash.inbox.user.add_url")))]
                        )
                      : _vm._e(),
                    _vm.showAddUrl
                      ? _c("div", { staticClass: "container-input" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.urlToAdd,
                                expression: "urlToAdd",
                              },
                            ],
                            ref: "inputTitle",
                            attrs: {
                              placeholder: _vm.$t(
                                "dash.inbox.user.url_placeholder"
                              ),
                              type: "text",
                              name: "url",
                            },
                            domProps: { value: _vm.urlToAdd },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.addUrl.apply(null, arguments)
                              },
                              blur: _vm.hideInput,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.urlToAdd = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "fa-solid fa-check",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addUrl.apply(null, arguments)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "container-title" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dash.inbox.user.notes.title")) + " "),
              ]),
              !_vm.showAddNote
                ? _c(
                    "div",
                    {
                      staticClass: "add",
                      on: {
                        click: function ($event) {
                          return _vm.showInput("note")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-regular fa-note" }),
                      _vm._v("Ajouter une note"),
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "add", on: { click: _vm.addNote } },
                    [
                      _c("i", { staticClass: "fa-solid fa-check" }),
                      _vm._v("Ajouter la  note"),
                    ]
                  ),
            ]),
            _c("div", { staticClass: "notes" }, [
              _vm.userDetail._source
                ? _c(
                    "ul",
                    [
                      _vm.showAddNote
                        ? _c("li", { key: "addNote" }, [
                            _c("img", {
                              staticClass: "image-user",
                              attrs: {
                                src:
                                  _vm.localStorage &&
                                  _vm.localStorage.user &&
                                  JSON.parse(_vm.localStorage.user).avatar
                                    ? JSON.parse(_vm.localStorage.user).avatar
                                    : "img/avatar.jpg",
                              },
                            }),
                            _c("div", { staticClass: "container-message" }, [
                              _c("div", { staticClass: "message" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.noteToAdd,
                                      expression: "noteToAdd",
                                    },
                                  ],
                                  ref: "inputTitle",
                                  staticClass: "textarea-add",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "dash.inbox.user.note_placeholder"
                                    ),
                                    name: "note",
                                  },
                                  domProps: { value: _vm.noteToAdd },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.noteToAdd = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "more" }, [
                                _c("div", { staticClass: "date" }),
                                _c("i", {
                                  staticClass: "fa-solid fa-xmark",
                                  on: { click: _vm.hideInput },
                                }),
                                _c("i", {
                                  staticClass: "fa-solid fa-check",
                                  on: { click: _vm.addNote },
                                }),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._l(
                        _vm.userDetail._source.notes,
                        function (note, key) {
                          return _c("li", { key: key }, [
                            _c("img", {
                              staticClass: "image-user",
                              attrs: {
                                alt: `${JSON.parse(note).user.firstname} ${
                                  JSON.parse(note).user.lastname
                                }`,
                                src: JSON.parse(note).user.avatar,
                              },
                            }),
                            _c("div", { staticClass: "container-message" }, [
                              _c("div", { staticClass: "message" }, [
                                _c("p", [
                                  _vm._v(_vm._s(JSON.parse(note).message)),
                                ]),
                                note.isEdit
                                  ? _c("textarea", {
                                      staticClass: "textarea-edit",
                                      domProps: {
                                        value: JSON.parse(note).message,
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "more" }, [
                                _c("div", { staticClass: "date" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        `${_vm.$t(
                                          "dash.inbox.user.note.created_by"
                                        )} ${JSON.parse(note).user.firstname} ${
                                          JSON.parse(note).user.lastname
                                        } ${_vm.$t(
                                          "dash.inbox.user.note.the"
                                        )} ${_vm.formatDate(
                                          JSON.parse(note).date
                                        )} ${_vm.$t(
                                          "dash.inbox.user.note.at"
                                        )} ${_vm.formatHour(
                                          JSON.parse(note).date
                                        )}`
                                      ) +
                                      " \n              "
                                  ),
                                ]),
                                _c("i", { staticClass: "fa-solid fa-pen" }),
                                _c("i", {
                                  staticClass: "fa-regular fa-trash-can",
                                }),
                              ]),
                            ]),
                          ])
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left" }, [
      _c("i", { staticClass: "fa-solid fa-envelope" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left" }, [
      _c("i", { staticClass: "fa-solid fa-phone" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left" }, [
      _c("i", { staticClass: "fa-solid fa-link" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }